import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import commonNetwork from "../../common/api/commonNetwork"; 
import { FetchResultType } from "../fetchTypes";
export const getOrderChartSummaryList = createAsyncThunk(
  "/getOrderChartSummaryList/get",
  async (params:any, { rejectWithValue }) => {
    try {
      // authToken eklenecek cookie,local vs biryerden okunup
      const { data, errorMessage, isSuccess } = await commonNetwork.get("/dashboard/order-chart-summaries", params);
      if (isSuccess ) {
        return data;
      } else {
        return rejectWithValue(data);
      }
    } catch (e: any) {
      return rejectWithValue(e.data.message);
    }
  }
);

export type OrderChartSummaryList={
  salesAmount:Array<number>,
  salesCounts:Array<number>,
  errorAmount:Array<number>,
  errorCounts:Array<number>,
  refundAmount:Array<number>,
  refundCounts:Array<number>, 
  dateList: Array<string>
}

export interface OrderChartSummaryListStateType extends FetchResultType {
  orderChartSummaryList: OrderChartSummaryList,
}

export const orderChartSummaryListSlice = createSlice({
  name: "orderChartSummaryList",
  initialState: {
    orderChartSummaryList: [],
    isFetching: false,
    isSuccess: false,
    isError: false,
    errorMessage: "",
  },
  reducers: {
    clearState: (state) => {
      state.orderChartSummaryList = [];
      state.isFetching = false;
      state.isSuccess = false;
      state.isError = false;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getOrderChartSummaryList.fulfilled, (state, { payload }) => {
      state.orderChartSummaryList = payload;
      state.isFetching = false;
      state.isSuccess = true;
      state.isError = false;
      return state;
    });
    builder.addCase(getOrderChartSummaryList.rejected, (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      // state.errorMessage = payload.message;
    });
    builder.addCase(getOrderChartSummaryList.pending, (state) => {
      state.isFetching = true;
    });
  },
});
export const { clearState } = orderChartSummaryListSlice.actions;

export const orderChartSummaryListSelector = (state: any) => state.orderChartSummaryList;

export const orderChartSummaryListReducer = orderChartSummaryListSlice.reducer;
